import {updateCategoryApi} from "../../api/entities/categories";
import {createUpdateSlice} from "../genericCrudSlice";

const updateCategorySlice = createUpdateSlice('category', updateCategoryApi);
export const {init: initUpdateCategory} = updateCategorySlice.actions;
export const {updateEntity: updateCategory} = updateCategorySlice;
export default updateCategorySlice.reducer;